import React from 'react';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import BaseForm from '../../../../../components/form/BaseForm';
import Input from '../../../../../components/input/Input/Input';
import SearchBox from '../../../../../components/outline/SearchBox';
import RadioGroup from '../../../../../components/input/RadioGroup';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { TAG_GROUP_TYPE_SELECT_LIST } from '../../../../../constants/service/app/tagConstants';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  TAG_GROUP_LIST_SEARCH_DATA_MODEL,
  TAG_GROUP_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../store/modules/tag/models';
import './TagGroupListSearchBox.scss';

const TagListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { tagGroupName, tagGroupCreateDate, tagGroupType } = searchData;

  return (
    <SearchBox
      className="tag-group-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: TAG_GROUP_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
          isInit: true,
        });
        setData({
          path: [],
          value: TAG_GROUP_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*태그 그룹명 검색*/}
      <BaseForm
        label="태그 그룹명"
        content={
          <Input
            value={tagGroupName}
            onChange={(value) =>
              setData({
                path: ['tagGroupName'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*태그 그룹 생성일*/}
      <BaseForm
        label="태그 그룹 생성일"
        content={
          <DateRangePicker
            value={tagGroupCreateDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['tagGroupCreateDate'],
                value,
              })
            }
          />
        }
      />

      {/*태그 그룹 타입*/}
      <BaseForm
        label="태그 그룹 타입"
        content={
          <RadioGroup
            list={TAG_GROUP_TYPE_SELECT_LIST}
            value={tagGroupType}
            onChange={(value) =>
              setData({
                path: ['tagGroupType'],
                value,
              })
            }
            size="large"
          />
        }
      />
    </SearchBox>
  );
};

export default TagListSearchBox;
